export default {
  days: '   روز و ',
};
